import { render } from "./signup-confirmation.vue?vue&type=template&id=65bb8370&scoped=true"
import script from "./signup-confirmation.vue?vue&type=script&lang=js"
export * from "./signup-confirmation.vue?vue&type=script&lang=js"

import "./signup-confirmation.vue?vue&type=style&index=0&id=65bb8370&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bb8370"]])

export default __exports__